<template>
  <button 
    @click="openModal"
    class="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
  >
    <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
    </svg>
    Find Training Center
  </button>
</template>

<script setup>
import ModalService from '@services/ModalService'

const props = defineProps({
  personRole: {
    type: Object,
    required: true
  },
  initialSearch: {
    type: Object,
    default: () => ({})
  }
})

function openModal() {
  ModalService.spawn('FindMissingRelatableModal', {
    personRole: props.personRole,
    initialSearch: props.initialSearch
  })
}
</script>
